import { Observable, observe, Scope } from 'wdc-cube'
import { GrupoRow } from './grupo.types'
import { WaitingScope } from 'src/components/waiting/waiting.scopes'

@Observable
export class HeaderScope extends Scope {}

@Observable
export class GrupoScope extends Scope {
    readonly header = new HeaderScope()
    
    @observe() waiting?: WaitingScope

    @observe() grupos = [] as GrupoRow[]
    @observe() nomeGrupoInputRef = '' as string
    @observe() idSelected = 0 as number

    onFind = Scope.ASYNC_ACTION
    onNew = Scope.ASYNC_ACTION
    onEdit = Scope.ASYNC_ACTION
    onDelete = Scope.ASYNC_ACTION
}

export default GrupoScope
